export default __webpack_public_path__ + "locales/si/Common.json?hash=6f46f27d9970a7cd0fbfb271fe5fd7f7";